module.exports = "/assets/b4846b8c10dbc48e8a096d2f651f04cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/NY.png
// module id = 2787
// module chunks = 0